export default __webpack_public_path__ + "static/media/walletLoadingSolid.e51a0de8.svg";